"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFactory = void 0;
const index_1 = require("./Clients/index");
const SocketIoManager_1 = require("./Clients/Lib/SocketIoManager");
const dummyIdentity = {
    token: 'ZHVtbXlfdG9rZW4=',
    userId: 'dummy_token',
};
exports.ClientFactory = {
    createApplicationInfoClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.ApplicationInfoHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
    createCorrelationClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.CorrelationHttpClient(atlasEngineUrl, identity),
    createCronJobClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.CronjobHttpClient(atlasEngineUrl, identity),
    createDataObjectInstanceClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.DataObjectInstanceHttpClient(atlasEngineUrl, identity),
    createEmptyActivityClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.EmptyActivityHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
    createEventClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.EventHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
    createExternalTaskClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.ExternalTaskClient(atlasEngineUrl, identity),
    createFlowNodeInstanceClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.FlowNodeInstanceHttpClient(atlasEngineUrl, identity),
    createManualTaskClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.ManualTaskHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
    createNotificationClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.NotificationHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
    createProcessDefinitionClient: (atlasEngineUrl, identity = dummyIdentity) => {
        if (isNodeEnvironment()) {
            return new index_1.ProcessDefinitionHttpClientNode(atlasEngineUrl, identity);
        }
        return new index_1.ProcessDefinitionHttpClient(atlasEngineUrl, identity);
    },
    createProcessInstanceClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.ProcessInstanceHttpClient(atlasEngineUrl, identity),
    createProcessModelClient: (atlasEngineUrl, identity = dummyIdentity) => new index_1.ProcessModelHttpClient(atlasEngineUrl, identity),
    createUserTaskClient: (atlasEngineUrl, identity = dummyIdentity, socketIoManager) => {
        socketIoManager = socketIoManager !== null && socketIoManager !== void 0 ? socketIoManager : new SocketIoManager_1.SocketIoManager(atlasEngineUrl);
        return new index_1.UserTaskHttpClient(atlasEngineUrl, identity, socketIoManager);
    },
};
function isNodeEnvironment() {
    return typeof window === 'undefined';
}
//# sourceMappingURL=ClientFactory.js.map